import { MessageType, AnnotationMessageType, MessageFlags } from 'app/modules/remote-control-ng/definitions';
import { MemoryBuffer } from '../../utils/memoryBuffer';
import { BaseMessage } from '../baseMessage';

export interface IAgentAnnotationResult {
    deviceId: string;
    toggleState?: number;
    errorCode: number;
}

/** PC_ANNOTATION MessageType */
export class AnnotationMessage extends BaseMessage {
    public response?: IAgentAnnotationResult;
    public messageType: AnnotationMessageType | 0;

    constructor() {
        super();
        this.header.command = MessageType.PC_ANNOTATION;
    }

    public deserializeBody(buffer: MemoryBuffer): void {
        this.response = <IAgentAnnotationResult>{};
        this.response.errorCode = this.header.errorCode || 0;
        this.messageType = buffer.readUInt8();
        this.response = <IAgentAnnotationResult>{};
        if (!(this.header.flags & MessageFlags.HAS_REQID)) {
            if (this.messageType === AnnotationMessageType.AM_TOGGLE_ANNOTATION) {
                this.response.toggleState = buffer.readUInt8();
            }
        }
    }
}

/** PC_ANNOTATION MessageType, AM_SET_PEN subcommand. Can be sent as a request */
export class AnnotationSetPenMessage extends AnnotationMessage {
    private color: string;
    private width: number;

    constructor(color: string, width: number) {
        super();
        this.color = color;
        this.width = width;
    }

    public serializeBody(buffer: MemoryBuffer): void {
        buffer.writeUInt8(AnnotationMessageType.AM_SET_PEN);

        // write color as string '#...'
        buffer.writeStringLE(this.color);
        // write sroke as an int32
        buffer.writeInt32BE(this.width);
    }
}

/** PC_ANNOTATION MessageType, AM_SET_ERASER subcommand. Can be sent as a request */
export class AnnotationEraserMessage extends AnnotationMessage {
    private width: number;

    constructor(width: number) {
        super();
        this.width = width;
    }

    public serializeBody(buffer: MemoryBuffer): void {
        buffer.writeUInt8(AnnotationMessageType.AM_SET_ERASER);

        // write sroke as an int32
        buffer.writeInt32BE(this.width);
    }
}

/** PC_ANNOTATION MessageType, AM_CLEAR_ANNOTATION subcommand. Can be sent as a request */
export class AnnotationClearMessage extends AnnotationMessage {
    public serializeBody(buffer: MemoryBuffer): void {
        buffer.writeUInt8(AnnotationMessageType.AM_CLEAR_ANNOTATION);
    }
};

/** PC_ANNOTATION MessageType, AM_RESET_ANNOTATION subcommand. Can be sent as a request */
export class AnnotationResetMessage extends AnnotationMessage {
    public serializeBody(buffer: MemoryBuffer): void {
        buffer.writeUInt8(AnnotationMessageType.AM_RESET_ANNOTATION);
    }
};

/** PC_ANNOTATION MessageType, AM_START_ANNOTATION subcommand. Can be sent as a request */
export class AnnotationStartAnnotationMessage extends AnnotationMessage {
    private drawingMode: number;
    private userMode: number;

    constructor(drawingMode: number, userMode: number) {
        super();
        this.drawingMode = drawingMode;
        this.userMode = userMode;
    }

    public serializeBody(buffer: MemoryBuffer): void {
        buffer.writeUInt8(AnnotationMessageType.AM_START_ANNOTATION);
        buffer.writeUInt8(this.drawingMode);
        buffer.writeUInt8(this.userMode);
    }
};

/** PC_ANNOTATION MessageType, AM_ANNOTATION_LASER subcommand. Can be sent as a request */
export class AnnotationSetLaserModeMessage extends AnnotationMessage {
    public serializeBody(buffer: MemoryBuffer): void {
        buffer.writeUInt8(AnnotationMessageType.AM_ANNOTATION_LASER);
    }
};

/** PC_ANNOTATION MessageType, AM_TOGGLE_ANNOTATION subcommand. Can be sent as a request */
export class AnnotationToggleMessage extends AnnotationMessage {
    private toggleState: number;
    constructor(toggleState: number) {
        super();
        this.toggleState = toggleState;
    }

    public serializeBody(buffer: MemoryBuffer): void {
        buffer.writeUInt8(AnnotationMessageType.AM_TOGGLE_ANNOTATION);
        buffer.writeUInt8(this.toggleState);
    }
};

/** PC_ANNOTATION MessageType, AM_STOP_ANNOTATION subcommand. Can be sent as a request */
export class AnnotationStopMessage extends AnnotationMessage {
    public serializeBody(buffer: MemoryBuffer): void {
        buffer.writeUInt8(AnnotationMessageType.AM_STOP_ANNOTATION);
    }
};
